<template>
  <v-card class="wrapper table-wrapper d-flex flex-column pa-4 ma-0 gap-1">
    <AppBar
      :secondary="secondary"
      :id="itemID"
      :edit="isEditMode"
      :loader="isLoading"
      @get-items="handleGetItems"
      @open-filters="handleFilters"
      :salary-factor-items="items"
    />
    <div
      v-if="initialLoading"
      class="mt-4"
      style="height: calc(100vh - 158px); overflow: hidden"
    ></div>
    <TableList
      v-show="!initialLoading"
      @call-refresh="handleChange"
      @initial-Loading-is="handleLoading"
      :call-refresh="refresh"
      :call-delete="callDelete"
      @salary-factor-items="handleItems"
      @close-dialog-permision="closePermision"
      @open-dialog-permision="openPermision"
      class=""
    />
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn color="primary" @click="remove()">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Refresh overlay -->
    <v-overlay absolute :value="refresh" opacity="0.1">
      <v-progress-circular indeterminate size="26" width="3" color="primary" />
    </v-overlay>
  </v-card>
</template>

<script>
import AppBar from "@/views/dashboard/pages/payroll/saleryFactors/partial/AppBar.vue";
import TableList from "@/views/dashboard/pages/payroll/saleryFactors/partial/TableList.vue";

export default {
  name: "salaryFactor",
  components: {
    AppBar,
    TableList,
  },
  data: () => ({
    refresh: false,
    callDelete: false,
    deletDialog: false,
    openNavigationDrawer: false,
    initialLoading: true,
    secondary: false,
    isLoading: false,
    isEditMode: false,
    items: null,
    itemID: null,
  }),
  created() {
    this.secondary = true;
  },
  methods: {
    handleItems(val) {
      this.items = val;
    },
    handleGetItems() {
      this.refresh = true;
      this.initialLoading = false;
    },
    handleChange() {
      this.refresh = false;
    },
    handleFilters() {
      this.openNavigationDrawer = true;
    },
    handleCloseFilter() {
      this.openNavigationDrawer = false;
    },
    handleLoading(val) {
      this.initialLoading = val;
    },
    closePermision() {
      this.deletDialog = false;
      this.callDelete = false;
    },
    openPermision() {
      this.deletDialog = true;
    },
    remove() {
      this.callDelete = true;
    },
  },
};
</script>

<style scoped>
.wrapper {
  height: calc(100vh - 100px);
  width: 100%;
}
.table-wrapper {
  position: relative;
  min-height: 300px;
}
</style>
